import React, { FC } from 'react'
import { getItemOrFirstEntry } from '@/utils/array-utils'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useGiveawayContext } from '../../context/GiveawayContext'
import { OverlayYoutubeVideo } from './OverlayYouTubeVideo'
import { ShareGiveawayModal } from './ShareGiveawayModal'

export const GiveawayModals: FC = () => {
  const {
    isScenePlayerOpen,
    setIsScenePlayerOpen,
    togglePauseBackgroundVideo,
    isShareModalOpen,
    setIsShareModalOpen,
    content,
  } = useGiveawayContext()

  const { query } = useSafeRouter()
  const sceneId = getItemOrFirstEntry(query?.sceneId)
  const { shareModal, rulesUrl } = content

  return (
    <>
      {sceneId && (
        <OverlayYoutubeVideo
          isOpen={isScenePlayerOpen}
          onClose={() => {
            setIsScenePlayerOpen(false)
            togglePauseBackgroundVideo() // Remove the argument
          }}
          youtubeID={sceneId}
        />
      )}

      {shareModal && (
        <ShareGiveawayModal
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          imageUrl={shareModal.desktopImageUrl || ''}
          imageUrlMobile={shareModal.mobileImageUrl || ''}
          shareText={shareModal.shareText || ''}
          rulesLink={rulesUrl}
        />
      )}
    </>
  )
}
